import {
  DayOfWeek, IDailyTimeTypes, IFlattenedTimeType, TimeSlotType, TimeSpan,
} from 'fitbeat.models';
import { TimeType } from './TimeType';

export class Day {
  public static toDailyTypes(days: Day[]): IDailyTimeTypes {
    return {
      [DayOfWeek.Monday]: days[1].toFlattenedTimeTypes(),
      [DayOfWeek.Tuesday]: days[2].toFlattenedTimeTypes(),
      [DayOfWeek.Wednesday]: days[3].toFlattenedTimeTypes(),
      [DayOfWeek.Thursday]: days[4].toFlattenedTimeTypes(),
      [DayOfWeek.Friday]: days[5].toFlattenedTimeTypes(),
      [DayOfWeek.Saturday]: days[6].toFlattenedTimeTypes(),
      [DayOfWeek.Sunday]: days[0].toFlattenedTimeTypes(),
    };
  }

  constructor(
    public readonly timeTypes: TimeType[],
  ) { /* no-op */ }

  public opensAt(): string {
    let earliestHour = TimeSpan.getHour(this.timeTypes[0].timeSpan.start);
    let earliestMinute = TimeSpan.getMinute(this.timeTypes[0].timeSpan.start);
    this.timeTypes.forEach((timeType) => {
      if (TimeSpan.getHour(timeType.timeSpan.start) < earliestHour
                || (TimeSpan.getHour(timeType.timeSpan.start) === earliestHour
                    && TimeSpan.getMinute(timeType.timeSpan.start) < earliestMinute)) {
        earliestHour = TimeSpan.getHour(timeType.timeSpan.start);
        earliestMinute = TimeSpan.getMinute(timeType.timeSpan.start);
      }
    });
    return `${earliestHour}${earliestMinute}`;
  }

  public closesAt(): string {
    let latestHour = TimeSpan.getHour(this.timeTypes[0].timeSpan.start);
    let latestMinute = TimeSpan.getMinute(this.timeTypes[0].timeSpan.start);
    this.timeTypes.forEach((timeType) => {
      if (TimeSpan.getHour(timeType.timeSpan.start) > latestHour
                || (TimeSpan.getHour(timeType.timeSpan.start) === latestHour
                    && TimeSpan.getMinute(timeType.timeSpan.start) > latestMinute)) {
        latestHour = TimeSpan.getHour(timeType.timeSpan.start);
        latestMinute = TimeSpan.getMinute(timeType.timeSpan.start);
      }
    });
    return `${latestHour}${latestMinute}`;
  }

  public getTimeSlotType(hhmm: string): TimeSlotType | undefined {
    const date = TimeSpan.generateDateFromHHMMString(hhmm);
    for (const timeType of this.timeTypes) {
      if (timeType.timeSpan.isTimeInRange(date)) {
        return timeType.type;
      }
    }
    // TODO #2501 "undefined" is used here as an unconfigured slot. could it use None instead?
    return undefined;
  }

  public toFlattenedTimeTypes(): IFlattenedTimeType[] {
    return this.timeTypes.map((t) => ({
      start: t.timeSpan.start,
      end: t.timeSpan.end,
      type: t.type,
    }));
  }
}
